module.exports = __webpack_public_path__ + "img/C.63c46d59.png";